"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultResultPropertyRenderer = exports.defaultResultGroupRenderer = void 0;
const React = __importStar(require("react"));
const AmountFormatSelector = __importStar(require("../amount-format-selector"));
const ResultElements = __importStar(require("./elements"));
const defaultResultGroupRenderer = (resultPropertyRenderer, formatSelectorRenderer, showLabels, group) => {
    return (React.createElement(ResultElements.GroupContainer, { key: group.key },
        group.key !== "no-group" && React.createElement("h2", null, group.translatedName),
        React.createElement(ResultElements.Table, null,
            React.createElement("tbody", null, group.properties.map(resultProperty => {
                return resultPropertyRenderer(formatSelectorRenderer, showLabels, resultProperty);
            })))));
};
exports.defaultResultGroupRenderer = defaultResultGroupRenderer;
const defaultResultPropertyRenderer = (FormatSelectorRenderer, showLabels, resultProperty) => {
    return (React.createElement("tr", { key: resultProperty.propertyName },
        showLabels && (React.createElement("td", null,
            React.createElement(ResultElements.PropertyLabel, { bold: !!(resultProperty.styleDefinition &&
                    resultProperty.styleDefinition.bold) }, resultProperty.translatedName))),
        React.createElement("td", null, resultProperty.formattedValue || React.createElement("span", null, "\u00A0")),
        React.createElement("td", null,
            React.createElement(FormatSelectorRenderer, Object.assign({}, resultProperty, { AmountFormatSelector: AmountFormatSelector.AmountFormatSelectorWithPadding, propertyType: resultProperty.type, onFormatChanged: (unit, decimalCount) => {
                    resultProperty.saveAmountFieldFormat(unit, decimalCount);
                }, onFormatCleared: resultProperty.deleteAmountFieldFormat, onFormatSelectorActiveChanged: resultProperty.toggleQuantitySelector })))));
};
exports.defaultResultPropertyRenderer = defaultResultPropertyRenderer;
//# sourceMappingURL=default-renderers.js.map